import { NavLink, Outlet, useNavigate } from 'react-router';
import { useAuthStore } from '../../store/auth.store';
import { logout } from '../../services/auth';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `block px-4 py-2 rounded transition ${
    isActive
      ? 'bg-red-600/20 text-red-400 border-l-2 border-red-500'
      : 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'
  }`;

export function Layout() {
  const user = useAuthStore((s) => s.user);
  const nav = useNavigate();

  function handleLogout() {
    logout();
    nav('/login');
  }

  return (
    <div className="flex h-screen">
      <aside className="w-60 bg-[#161a1f] border-r border-[#2a2f36] flex flex-col">
        <div className="p-4 border-b border-[#2a2f36]">
          <h1 className="text-lg font-bold text-red-500">Oraculo</h1>
          <p className="text-xs text-gray-500 mt-1">AntiHack — admin</p>
        </div>

        <nav className="flex-1 p-2 space-y-1">
          {/* Fase 3 — a fila de ban vai no TOPO de propósito: é a tela em que
              o dono decide, e ficaria enterrada abaixo de doze telas de
              diagnóstico se seguisse a ordem de quando foi escrita. */}
          <NavLink to="/ban-queue" className={navLinkClass}>🎯 Fila de ban</NavLink>
          <NavLink to="/accounts" className={navLinkClass}>Contas / jogadores</NavLink>

          <NavLink to="/dashboard" className={navLinkClass}>Dashboard</NavLink>
          <NavLink to="/efficacy" className={navLinkClass}>Eficácia</NavLink>
          <NavLink to="/sessions" className={navLinkClass}>Sessions</NavLink>
          <NavLink to="/events" className={navLinkClass}>Events</NavLink>
          <NavLink to="/kill-switches" className={navLinkClass}>Kill switches</NavLink>
          <NavLink to="/rulesets" className={navLinkClass}>Rulesets</NavLink>
          <NavLink to="/releases" className={navLinkClass}>Releases</NavLink>
          <NavLink to="/client-builds" className={navLinkClass}>Client Builds</NavLink>
          <NavLink to="/sanctions" className={navLinkClass}>Sanctions</NavLink>

          {/* Sessão 1 Frente A — Operação avançada */}
          <div className="pt-2 mt-2 border-t border-[#2a2f36]">
            <p className="text-[10px] text-gray-600 uppercase tracking-wide px-4 mb-1">Operação avançada</p>
            <NavLink to="/incidents" className={navLinkClass}>Incidents</NavLink>
            <NavLink to="/investigations/ip/127.0.0.1" className={navLinkClass}>Investigations</NavLink>
            <NavLink to="/trusted-proxies" className={navLinkClass}>Trusted Proxies</NavLink>
          </div>

          <NavLink to="/diagnostics" className={navLinkClass}>Diagnostics</NavLink>
          <NavLink to="/support-diag" className={navLinkClass}>Support Diag</NavLink>
          <NavLink to="/cleanup" className={navLinkClass}>Cleanup (LGPD)</NavLink>
          <NavLink to="/reports/daily" className={navLinkClass}>Reports</NavLink>
        </nav>

        <div className="p-4 border-t border-[#2a2f36]">
          <p className="text-xs text-gray-500 truncate" title={user?.email}>{user?.email}</p>
          <button
            type="button"
            onClick={handleLogout}
            className="mt-2 w-full text-left text-sm text-gray-400 hover:text-red-400 transition"
          >
            Sair
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
